/**
 * @generated SignedSource<<46d8b2f5584c16009ebdecdf2da04373>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchFederatedEmail_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultFederated";
  readonly description: string;
  readonly entity: {
    readonly sender?: {
      readonly name: string | null;
    } | null;
  } | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchFederatedEmail_AtlassianSearchPage";
};
export type searchFederatedEmail_AtlassianSearchPage$key = {
  readonly " $data"?: searchFederatedEmail_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchFederatedEmail_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchFederatedEmail_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "SearchFederatedEmailUser",
              "kind": "LinkedField",
              "name": "sender",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ]
            }
          ],
          "type": "SearchFederatedEmailEntity"
        }
      ]
    }
  ],
  "type": "SearchResultFederated"
};

(node as any).hash = "fe6e2341012e955a1fe71d28c0a79382";

export default node;
